<template>
  <a-layout class="layout-demo">
    <a-layout-sider
      breakpoint="lg"
      :width="220"
      collapsible
      :collapsed="collapsed"
      @collapse="onCollapse"
    >
      <div class="logo" />
      <a-menu
        :defaultOpenKeys="['0']"
        :defaultSelectedKeys="['0_0']"
        @menuItemClick="onClickMenuItem"
      >
        <a-menu-item key="0_0">
          <IconBook />
          基本情况
        </a-menu-item>
        <a-menu-item key="0_1">
          <IconBook />
          人口情况
        </a-menu-item>
        <a-menu-item key="0_2">
          <IconBarChart />
          学生情况
        </a-menu-item>
        <a-menu-item key="0_3">
          <IconNav />
          教师情况
        </a-menu-item>
        <a-menu-item key="0_4">
          <IconHome />
          学校情况
        </a-menu-item>
        <a-menu-item key="0_6">
          <IconDashboard />
          学校布局
        </a-menu-item>
        <a-menu-item key="0_7">
          <IconBook />
          应对措施
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout style="padding: 0 24px">
        <!-- 修复：添加 min-height 确保内容区域有足够高度 -->
        <a-layout-content class="main-content">
          <component :is="currentComponent" />
        </a-layout-content>
        <!-- <a-layout-footer>Footer</a-layout-footer> -->
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script setup>
import { ref } from 'vue';
import { Message } from '@arco-design/web-vue';
import {
  IconHome,
  IconCalendar,
  IconBytedanceColor,
  IconBarChart,
  IconDashboard,
  IconBook,
  IconNav,
} from '@arco-design/web-vue/es/icon';
import Base from './dashboard/Base.vue';
import SchoolInfo from './dashboard/SchoolInfo.vue';
import Student from './dashboard/Student.vue';
import { useRouter } from 'vue-router';
import Teacher from './dashboard/Teacher.vue';
import Jbqk from './dashboard/Jbqk.vue';
import Ydcs from './dashboard/Ydcs.vue';
const router = useRouter();
const components = {
  Base,
  SchoolInfo,
  Student,
  Teacher,
  Jbqk,
  Ydcs,
};

// 响应式状态
const collapsed = ref(false);
const currentComponent = ref(Jbqk);

// 处理折叠事件
const onCollapse = (val, type) => {
  const content = type === 'responsive' ? '触发响应式收缩' : '点击触发收缩';
  Message.info({
    content,
    duration: 2000,
  });
  collapsed.value = val;
};

// 处理菜单项点击
const onClickMenuItem = (key) => {
  console.log(key);
  switch (key) {
    case '0_0':
      currentComponent.value = Jbqk;
      break;
    case '0_1':
      currentComponent.value = Base;
      break;
    case '0_2':
      currentComponent.value = Student;
      break;
    case '0_3':
      currentComponent.value = Teacher;
      break;
    case '0_4':
      currentComponent.value = SchoolInfo;
      break;
    case '0_6':
      router.push('/yuxi');
      break;
    case '0_7':
      currentComponent.value = Ydcs;
      break;
    default:
      Message.info({ content: `You select ${key}`, showIcon: true });
      break;
  }
};
</script>

<style scoped>
.layout-demo {
  height: 100vh;
  background: var(--color-fill-2);
  border: 1px solid var(--color-border);
}

.layout-demo :deep(.arco-layout-sider) .logo {
  height: 32px;
  margin: 12px 8px;
  background: rgba(255, 255, 255, 0.2);
}

.layout-demo :deep(.arco-layout-sider-light) .logo {
  background: var(--color-fill-2);
}

.layout-demo :deep(.arco-layout-header) {
  height: 64px;
  line-height: 64px;
  background: var(--color-bg-3);
}

.layout-demo :deep(.arco-layout-footer) {
  height: 48px;
  color: var(--color-text-2);
  font-weight: 400;
  font-size: 14px;
  line-height: 48px;
}

/* 修复内容区域样式 */
.main-content {
  min-height: calc(100vh - 64px);
  /* 减去可能的header高度 */
  color: var(--color-text-2);
  font-weight: 400;
  font-size: 14px;
  background: var(--color-bg-3);
  display: block;
  /* 改为block布局 */
}

/* 移除冲突的样式 */
.layout-demo :deep(.arco-layout-footer) {
  /* 保持原有样式 */
}
</style>
